<template>
    <div class="text-center">
        <p>
            Kamu akan bergabung sebagai
        </p>

        <v-avatar size="64" color="avatar">
            <v-icon color="white">mdi-account</v-icon>
        </v-avatar>

        <p class="title mt-2 mb-0">
            {{ $store.get('auth/name') }}
        </p>
        <div>
            <v-btn
                @click="switchAccount"
                text
                small
                class="mb-4"
                :loading="$store.get('loader/loading', 'switching')"
            >
                Bukan Kamu?
            </v-btn>
        </div>

        <v-alert
            type="warning"
            class="text-left text-md-center mx-0 mx-sm-4"
        >
            Kamu sudah bergabung di kelompok lain.
            Dengan bergabung ke kelompok ini kamu akan keluar dari kelompok kamu sekarang.
            Jika ini bukan kamu,
            <a @click="switchAccount" class="white--text font-weight-bold">ganti akun</a>
        </v-alert>

        <div>
            <v-btn
                @click="join"
                color="primary"
                :loading="$store.get('loader/loading', 'joining')"
            >
                Gabung
            </v-btn>
        </div>
    </div>
</template>

<script>
import { USER_AUTH } from '@/store/groupjoin'

export default {
    computed: {
        alreadyJoinOtherGroup() {
            const userGroup = this.$store.get('auth/group_hash')

            return !!userGroup && this.$store.get('groupjoin/groupHash') !== userGroup
        }
    },

    methods: {
        switchAccount() {
            this.$api.delete('auth', { loader: 'switching' })
                .then(() => {
                    this.$store.dispatch('auth/unsetData')

                    this.$store.set('groupjoin/status', USER_AUTH)
                })
        },

        join() {
            this.$api.patch('auth/group', {
                group_hash: this.$store.get('groupjoin/groupHash'),
            }, { loader: 'joining' })
                .then(() => {
                    this.$router.replace({ name: this.$store.get('groupjoin/groupRoute') })
                })
        },
    }
}
</script>
